import { render, staticRenderFns } from "./RepoBrowser.vue?vue&type=template&id=218cbf9b&scoped=true&"
import script from "./RepoBrowser.vue?vue&type=script&lang=js&"
export * from "./RepoBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218cbf9b",
  null
  
)

export default component.exports